import { defineComponent as _defineComponent } from 'vue'
import CcError from '@/views/Automation/CampaignCreatorV2/components/CcError/CcError.ts.vue';
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { FieldVariable } from '@/views/Automation/CampaignCreatorV2/store/AbVariables';
import moment from 'moment';
import { computed } from 'vue';
import VueTimepicker from 'vue2-timepicker';
import Datepicker from 'vuejs-datepicker';

type Props = {
  title: string;
  date: Date;
  field: FieldVariable<any, any>;
};

interface Emits {
  (e: 'update', value: { date: Date }): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcDateTimePicker.ts',
  props: {
    title: { default: '' },
    date: { default: () => new Date() },
    field: null
  },
  emits: ["update"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update', value: { date: Date }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string, date: Date, field: FieldVariable<any, any> };





function emitChanges(date: Date) {
  // check if date is the same using moment
  if (moment(date).isSame(props.date, 'minute')) return;
  emits('update', { date });
}
function changeDate(updatedDate: Date) {
  const newValue = moment(props.date)
    .set({
      year: updatedDate.getFullYear(),
      month: updatedDate.getMonth(),
      date: updatedDate.getDate(),
    })
    .toDate();
  // If the date is not changed, then don't emit the changes
  if (newValue.getTime() === props.date.getTime()) return;
  emitChanges(newValue);
}

function changeTime(time: { hh: string; mm: string; A: string }) {
  const calculatedHour = time.A === 'PM' ? +time.hh + 12 : +time.hh;
  const newValue = moment(props.date)
    .set({
      hour: +calculatedHour === 24 ? 12 : +calculatedHour,
      minute: +time.mm,
    })
    .toDate();
  emitChanges(newValue);
}

const time = computed(() => {
  const momentTime = moment(props.date || new Date());
  return {
    hh: momentTime.format('hh'),
    mm: momentTime.format('mm'),
    A: momentTime.format('A'),
  };
});

return { __sfc: true,props, emits, emitChanges, changeDate, changeTime, time, CcError, CcIcon, VueTimepicker, Datepicker }
}

})